import React, { useState, useEffect } from "react";
import { useTable } from "react-table";
import { useDispatch, useSelector } from "react-redux";
import { Form } from "react-bootstrap";
import axios from "axios";
import { motion } from "framer-motion";
import swal from "sweetalert";
import { Spinner } from "react-bootstrap";

import { useHistory } from "react-router-dom";

import { socket } from "../../services/socket/socket";
import * as actionTypes from "../../redux/actionTypes";

import arrowLeftGreen from "../../assets/arrowLeftGreen.svg";
import { Submit } from "../../Components/Button";
import { groupingColumn } from "./groupingColumn";
import { Navbar } from "../../Components/Navbar";
import { groupings } from "../../Components/BalanceSheet/mockGrouping";
import TABLE_MOCK from "../../Components/Table/TABLE_MOCK.json";
import "./preview.css";
import { SelectComponent } from "../../Components/Table/BasicTable";
import { fetchConventionalMode, updateConventionalMode } from "../../redux/actions/TemplateTabs/actionCM";
import { fetchTTGroupData } from "../../redux/actions/TemplateTabs/actionGrouping";

import { Button } from "../../myfin_v2/elements/Button";
import commoncss from "../../myfin_v2/css/common.module.css"
import buttoncss from "../../myfin_v2/css/button.module.css"
// import BookClosureTable from "../../myfin_v2/elements/BookClosureTable";
import { ReactComponent as FilterIcon } from "../../myfin_v2/assets/icons/filter.svg";
import { ReactComponent as SearchIcon } from "../../myfin_v2/assets/icons/searchPri.svg";
import { ReactComponent as ExportIcon } from "../../myfin_v2/assets/icons/download.svg";
import { ReactComponent as EditIcon } from "../../myfin_v2/assets/icons/edit.svg";
import Breadcrumb from "../../myfin_v2/components/Breadcrumb";
import Sidebar from "../../myfin_v2/elements/Sidebar"
import bookclosuretablecss from "../../myfin_v2/css/bookclosuretable.module.css";
import tablecss from "../../myfin_v2/css/table.module.css";
import Checkmark from "../../myfin_v2/assets/icons/Check(circle).png";


const board = {
  padding: "2rem 4rem",
  minWidth: "1045px",
  backgroundColor: "#E5E5E5",
  minHeight: "calc(100vh - 80px)",
};

const groupingScreen = {
  // backgroundColor:'white',
  width: "100%",
  height: "80vh",
  paddingRight: "15px",
  // overflowY:'scroll',
  borderRadius: "10px",
};

const groupingNav = {
  backgroundColor: "white",
  width: "100%",
  height: "80px",
  borderTopRightRadius: "10px",
  display: "flex",
  justifyContent: "space-between",
  padding: "0 2rem",
  alignItems: "center",
  position: "sticky",
  top: "0",
};
const groupingTable = {
  backgroundColor: "white",
  width: "100%",
  minHeight: "65vh",
  maxHeight: "65vh",
  overflowY: "scroll",
};

const backNav = {
  fontSize: "1.2rem",
  fontWeight: "600",
  color: "#03565A",
  cursor: "pointer",
};

const formatNumber = (val) => {
  if (val === undefined || val === null || isNaN(val)) return "-";

  const roundedVal = Math.round(Number(val));

  if (roundedVal === 0) return "-";

  if (roundedVal < 0) {
    return `(${Math.abs(roundedVal).toLocaleString("en-IN")})`;
  }

  return roundedVal.toLocaleString("en-IN");
};

const PreviewPage = () => {
  let history = useHistory();
  const dispatch = useDispatch();
  const fSData = useSelector(
    (initialState) => initialState.reducer.currentClassification || []
  );
  const [fs, setFs] = useState([]);
  const [projectName, setProjectName] = useState("Standalone");
  const [edit, setEdit] = useState(false);
  const [loading, setLoading] = useState(false);
  const [showSuccessPopup, setShowSuccessPopup] = useState(false);
  const [random, setRandom] = useState("");
  const index = fSData.length;
  const auth = localStorage.getItem("auth_token");
  const project_id = localStorage.getItem("project_id");
  const tb_id = localStorage.getItem("tb_id");

  const TB_ID = useSelector((initialState) => initialState.reducer.tb_id);
  const Name = useSelector(
    (initialState) => initialState.reducer.currentClassificationName
  ) || localStorage.getItem("currentClassificationName");
  const py = Array.isArray(fSData) ? fSData?.find((data) => data.hasOwnProperty('header'))?.py ?? 0 : 0;
  const cy = Array.isArray(fSData) ? fSData?.find((data) => data.hasOwnProperty('header'))?.cy ?? 0 : 0;
  const { checkYearly } = useSelector((state) => state.selectedDragReducer);

  const TTGrouping = useSelector((state) => state.TTGroupingReducer);
  const groupDataRes = TTGrouping.response ?? [];
  const user = JSON.parse(localStorage.getItem('user'));

  const conventionModeData = useSelector(
    (state) => state.ConventionModeReducer
  );

  const workspace_data = useSelector((state) => state.WSReducer);
  const workspaceName = workspace_data?.response?.[0]?.workspace_name || sessionStorage.getItem("adj_workspace_name") || localStorage.getItem("workspaceName") || "Workspace";


  useEffect(() => {
    fetchFsData();
    getConventionalMode();
    if (!TTGrouping.isSuccess || TTGrouping.set_payload !== JSON.stringify({ project_id, tb_id })) {
      dispatch(fetchTTGroupData(project_id, tb_id));
    }
  }, []);

  useEffect(() => {
    if (Array.isArray(fSData)) {
      setFs(fSData.filter(data => !data.hasOwnProperty('header')));
    } else {
      setFs([]);
    }
  }, [fSData]);

  let headers = {
    "x-auth-token": auth,
  };

  const getConventionalMode = async () => {
    if (
      !conventionModeData.isSuccess ||
      conventionModeData.set_payload !== JSON.stringify({ project_id, tb_id })
    ) {
      dispatch(fetchConventionalMode(project_id, tb_id));
    }
  };

  function HandleSave() {
    fetchFsData();
    if (edit) {
      setShowSuccessPopup(true);
      setTimeout(() => setShowSuccessPopup(false), 2000);
    }
    setEdit(!edit);
  }

  const fetchFsData = () => {
    const effectiveTbId = TB_ID || tb_id;
    if (!effectiveTbId || !Name) return;
    setLoading(true);
    axios
      .get(`/api/v1/fs-classification/get-fs/${project_id}/${effectiveTbId}`, {
        headers,
      })
      .then((response) => {
        const data = response.data.classification_list[Name];
        setProjectName(response.data?.project?.project_name)
        dispatch({ type: actionTypes.SET_CLASSIFICATION, payload: data });
      })
      .catch((error) => {
        console.log(error.response, "error");
      })
      .finally(() => {
        setLoading(false);
      });
  };


  const { getTableProps, getTableBodyProps, headerGroups, rows, prepareRow } =
    useTable({
      columns: groupingColumn,
      // data: TABLE_MOCK
      data: fs,
    });

  const handleMap = async (type, row, change, type2) => {
    if (!change) return;
    switch (type) {
      case "fs_grp": {
        const mapData = {
          fs_grp: change,
          note_grp: "",
          sub_grp: "",
          note_no: ""
        }
        let updatedData = {
          ...row
        }
        if (checkYearly) {
          const cyMapVal = type2 === "cy" ? { ...mapData } : (row.map_data?.cy_map || {
            fs_grp: row.fs_grp || "",
            note_grp: row.note_grp || "",
            note_no: row.note_no || "",
            sub_grp: row.sub_grp || ""
          });
          const pyMapVal = type2 === "py" ? { ...mapData } : (row.map_data?.py_map || {
            fs_grp: row.fs_grp || "",
            note_grp: row.note_grp || "",
            note_no: row.note_no || "",
            sub_grp: row.sub_grp || ""
          });
          updatedData = {
            ...updatedData,
            map_data: {
              ...updatedData.map_data,
              cy_map: cyMapVal,
              py_map: pyMapVal
            }
          };
        } else {
          updatedData = {
            ...updatedData, map_data: {
              ...updatedData.map_data,
              cy_map: { ...mapData },
              py_map: { ...mapData }
            }
          };
        }

        //? written for update data in table locally
        const element = fs.find(ele => ele.lid === row.lid);
        if (element) {
          element.map_data = updatedData.map_data;
        }
        setFs([...fs]);

        dispatch(updateConventionalMode(conventionModeData.set_payload, updatedData))
        return true
      }
      case "note_grp": {
        let parseChange = JSON.parse(change);
        const mapData = {
          fs_grp: row?.map_data?.[type2 + '_map']?.fs_grp || row.fs_grp,
          note_grp: parseChange.notes_grp,
          note_no: parseChange.notes_no,
          sub_grp: "",
        }
        let updatedData = {
          ...row
        }
        if (checkYearly) {
          const cyMapVal = type2 === "cy" ? { ...mapData } : (row.map_data?.cy_map || {
            fs_grp: row.fs_grp || "",
            note_grp: row.note_grp || "",
            note_no: row.note_no || "",
            sub_grp: row.sub_grp || ""
          });
          const pyMapVal = type2 === "py" ? { ...mapData } : (row.map_data?.py_map || {
            fs_grp: row.fs_grp || "",
            note_grp: row.note_grp || "",
            note_no: row.note_no || "",
            sub_grp: row.sub_grp || ""
          });
          updatedData = {
            ...updatedData,
            map_data: {
              ...updatedData.map_data,
              cy_map: cyMapVal,
              py_map: pyMapVal
            }
          };
        } else {
          updatedData = {
            ...updatedData, map_data: {
              ...updatedData.map_data,
              cy_map: { ...mapData },
              py_map: { ...mapData }
            }
          };
        }
        //? written for update data in table locally
        const element = fs.find(ele => ele.lid === row.lid);
        if (element) {
          element.map_data = updatedData.map_data;
        }
        setFs([...fs]);

        dispatch(updateConventionalMode(conventionModeData.set_payload, updatedData))
        return true
      }
      case "sub_grp": {
        const mapData = {
          fs_grp: row?.map_data?.[type2 + '_map']?.fs_grp || row.fs_grp,
          note_grp: row?.map_data?.[type2 + '_map']?.note_grp || row.note_grp,
          note_no: row?.map_data?.[type2 + '_map']?.note_no || row.note_no,
          sub_grp: change
        }
        let updatedData = {
          ...row,
        }
        if (checkYearly) {
          const cyMapVal = type2 === "cy" ? { ...mapData } : (row.map_data?.cy_map || {
            fs_grp: row.fs_grp || "",
            note_grp: row.note_grp || "",
            note_no: row.note_no || "",
            sub_grp: row.sub_grp || ""
          });
          const pyMapVal = type2 === "py" ? { ...mapData } : (row.map_data?.py_map || {
            fs_grp: row.fs_grp || "",
            note_grp: row.note_grp || "",
            note_no: row.note_no || "",
            sub_grp: row.sub_grp || ""
          });
          updatedData = {
            ...updatedData,
            map_data: {
              ...updatedData.map_data,
              cy_map: cyMapVal,
              py_map: pyMapVal
            }
          };
        } else {
          updatedData = {
            ...updatedData, map_data: {
              ...updatedData.map_data,
              cy_map: { ...mapData },
              py_map: { ...mapData }
            }
          };
        }
        //? written for update data in table locally
        const element = fs.find(ele => ele.lid === row.lid);
        if (element) {
          element.map_data = updatedData.map_data;
        }
        setFs([...fs]);

        dispatch(updateConventionalMode(conventionModeData.set_payload, updatedData))
        return true
      }
      default:
        return false
    }
  }

  const handleGroupData = (type, row, mapType) => {
    let { fs_grp, note_grp } = row.original;
    if (row.original.hasOwnProperty('map_data') && row.original.map_data.hasOwnProperty(mapType)) {
      fs_grp = row.original.map_data[mapType].fs_grp;
      note_grp = row.original.map_data[mapType].note_grp;
    }

    switch (type) {
      case "fs_grp_cy":
        if (TTGrouping.isSuccess) {
          return groupDataRes?.fs_grp?.map(fsGrp => fsGrp.fs_grp)
        } else {
          return []
        }
      case "fs_grp_py":
        if (TTGrouping.isSuccess) {
          return groupDataRes?.fs_grp?.map(fsGrp => fsGrp.fs_grp)
        } else {
          return []
        }
      case "note_grp_cy":
        if (TTGrouping.isSuccess && fs_grp) {
          return groupDataRes?.fs_grp?.find(fsGrp => fsGrp.fs_grp === fs_grp)
            .notes_grp.map(notes => { return { notes_grp: notes.notes_grp, notes_no: notes.notes_no } })
        } else {
          return []
        }
      case "note_grp_py":
        if (TTGrouping.isSuccess && fs_grp) {
          return groupDataRes?.fs_grp?.find(fsGrp => fsGrp.fs_grp === fs_grp)
            .notes_grp.map(notes => { return { notes_grp: notes.notes_grp, notes_no: notes.notes_no } })
        } else {
          return []
        }
      case "sub_grp_cy":
        if (TTGrouping.isSuccess && fs_grp && note_grp) {
          return groupDataRes?.fs_grp?.find(fsGrp => fsGrp.fs_grp === fs_grp)
            ?.notes_grp.find(note => note.notes_grp === note_grp)?.sub_grp.map(subGrp => subGrp.sub_grp)
        } else {
          return []
        }
      case "sub_grp_py":
        if (TTGrouping.isSuccess && fs_grp && note_grp) {
          return groupDataRes?.fs_grp?.find(fsGrp => fsGrp.fs_grp === fs_grp)
            ?.notes_grp.find(note => note.notes_grp === note_grp)?.sub_grp.map(subGrp => subGrp.sub_grp)
        } else {
          return []
        }
      default:
        return []
    }
  }

  const breadcrumbItems = [
    {
      label: workspaceName,
      link: `/preview`,
      className: `${commoncss.nav_cnt_color} clickable`,
    },
    {
      label: `${projectName}`,
      link: `/preview`,
      className: `${commoncss.nav_cnt_color} clickable`,
    },
    {
      label: "Classification Preview",
      link: `/preview`,
      className: `${commoncss.nav_cnt_color} clickable`,
    },
    { label: `${Name}`, link: "", className: "headerLable" },
  ];

  const getAlignClass = (header) => {
    switch (header) {
      case "LEDGER CODE":
        return "text-left";
      case "LEDGER NAME":
        return "text-left";
      case "CURRENT YEAR":
        return "text-right";
      case "CURRENT YEAR":
        return "text-right";
      case "FINAL AMT":
        return "text-right";
      case "ADJUSTED AMT":
        return "text-right";
      case "PREVIOUS YEAR":
        return "text-right";
      default:
        return "text-center";
    }
  };

  return (
    <>
      <div className={commoncss.pageLayout}>
        <Sidebar />
        <div className={`d-flex ${commoncss.pageContent} preview-page-container`}>
          <motion.div
            initial={{ x: -100, opacity: 0 }}
            animate={{ x: 0, opacity: 1 }}
            exit={{ x: 0, opacity: 0 }}
            transition={{ duration: 0.5, ease: "easeInOut" }} className={commoncss.w100} style={{ maxHeight: "100vh", overflowY: "hidden" }} >

            <div className="fscp-header" style={{ padding: "15px 0px" }}>
              <Breadcrumb style="margin-right:auto"
                addCls={"bgClr1"}
                items={breadcrumbItems}
                headerActions={<></>}
              />
              {fSData.length === 0 ? (
                <Button
                  btnColor={edit ? buttoncss.primary : buttoncss.secondary}
                  style={!edit ? { backgroundColor: "transparent", border: "1px solid #7ecea7" } : {}}
                  
                  icon={!edit ? <EditIcon style={{ width: "17px", height: "17px", paddingRight: "2px" }} /> : null}
                  label={edit ? "Save Changes" : "Edit Changes"}
                  onClick={() => {
                    HandleSave();
                  }}
                  isEnabled={false}
                />
              ) : (
                <Button
                  btnColor={edit ? buttoncss.primary : buttoncss.secondary}
                  style={!edit ? { backgroundColor: "transparent", border: "1px solid #7ecea7" } : {}}
                  icon={!edit ? <EditIcon style={{ width: "17px", height: "17px", paddingRight: "2px" }} /> : null}
                  label={edit ? "Save Changes" : "Edit Changes"}
                  onClick={() => {
                    HandleSave();
                  }}
                  isEnabled={user.responsibilities != "view" || user.responsibilities != "approver"}
                />
              )}

            </div>

            <div className={`${tablecss.stdTableContainer}`} style={{ margin: "0 20px", width: "calc(100% - 40px)" }}>
              {loading ? (
                <div
                  style={{
                    display: "flex",
                    justifyContent: "center",
                    minHeight: "60vh",
                    alignItems: "center",
                  }}
                >
                  <Spinner animation="border" variant="success" />
                </div>
              ) : fSData.length === 0 ? (
                // "no"
                <div
                  style={{
                    display: "flex",
                    justifyContent: "center",
                    minHeight: "60vh",
                    alignItems: "center",
                  }}
                >
                  <h1
                    style={{
                      fontWeight: "500",
                      fontSize: "20px",
                      color: "lightgray",
                    }}
                  >
                    No Ledgers Mapped to current Classification: {Name}
                  </h1>
                </div>
              ) : (
                <table className={`${tablecss.customTable}`}  {...getTableProps()}>

                  <thead>
                    {headerGroups.map((headerGroup) => (
                      <tr {...headerGroup.getHeaderGroupProps()}>
                        {headerGroup.headers.map((column) => (
                          <th style={{
                            paddingTop: "20px",
                            paddingBottom: "20px",
                            maxWidth: "200px",
                            minWidth: column.render("Header") === "LEDGER CODE" ? "125px" : "200px"
                          }} className={`${getAlignClass(column.render("Header"))}`} {...column.getHeaderProps()}>
                            {column.render("Header")}
                          </th>
                        ))}
                      </tr>
                    ))}
                  </thead>
                  <tbody {...getTableBodyProps()} >
                    {rows.map((row, ind) => {
                      prepareRow(row);
                      return (
                        <tr {...row.getRowProps()}>
                          {row.cells.map((cell, i) => {
                            if (cell.column.Header == "ADJUSTED AMT") {
                              return (
                                <td
                                  style={{ textAlign: "right", padding: "10px" }}
                                >
                                  {formatNumber(cell?.row?.original?.adjusted_amount)}
                                </td>
                              );
                            }
                            if (cell.column.Header == "CURRENT YEAR") {
                              return (
                                <td
                                  {...cell.getCellProps()}
                                  style={{
                                    textAlign: "right",
                                    paddingRight: "10px",
                                  }}
                                >
                                  {formatNumber(cell?.row?.original?.cy)}
                                </td>
                              );
                            }
                            if (cell.column.Header == "PREVIOUS YEAR") {
                              return (
                                <td
                                  {...cell.getCellProps()}
                                  style={{
                                    textAlign: "right",
                                    paddingRight: "10px",
                                  }}
                                >
                                  {formatNumber(cell?.row?.original?.py)}
                                </td>
                              );
                            }

                            if (cell.column.Header == "FINAL AMT") {
                              const finalAmt = cell.row.original.isAdjusted 
                                ? (cell?.row?.original?.cy - cell?.row?.original?.adjusted_amount)
                                : cell.row.original?.cy;
                              
                              return (
                                <td
                                  style={{ textAlign: "right", padding: "10px" }}
                                >
                                  {formatNumber(finalAmt)}
                                </td>
                              );
                            }
                             if (cell.column.Header == "FS GROUPING (CY)") {
                              return (
                                <td
                                  {...cell.getCellProps({
                                    style: {
                                      minWidth: cell.column.minWidth,
                                      width: cell.column.width,
                                      maxWidth: cell.column.maxWidth,
                                    },
                                  })}
                                  className="dropMapping"
                                >
                                  <SelectComponent
                                    rowData={row}
                                    type={"fs_grp"}
                                    options={handleGroupData("fs_grp_cy", row, "cy_map")}
                                    handleChange={handleMap}
                                    checkYearly={checkYearly}
                                    type2={"cy"}
                                    disabled={!edit}
                                  />
                                </td>
                              );
                            }
                            if (cell.column.Header == "NOTES GROUPING (CY)") {
                              return (
                                <td
                                  {...cell.getCellProps({
                                    style: {
                                      minWidth: cell.column.minWidth,
                                      width: cell.column.width,
                                      maxWidth: cell.column.maxWidth,
                                    },
                                  })}
                                  className="dropMapping"
                                >
                                  <SelectComponent
                                    rowData={row}
                                    type={"note_grp"}
                                    options={handleGroupData("note_grp_cy", row, "cy_map")}
                                    handleChange={handleMap}
                                    checkYearly={checkYearly}
                                    type2={"cy"}
                                    disabled={!edit}
                                  />
                                </td>
                              );
                            }
                            if (cell.column.Header == "SUB GROUPING (CY)") {
                              return (
                                <td
                                  {...cell.getCellProps({
                                    style: {
                                      minWidth: cell.column.minWidth,
                                      width: cell.column.width,
                                      maxWidth: cell.column.maxWidth,
                                    },
                                  })}
                                  className="dropMapping"
                                >
                                  <SelectComponent
                                    rowData={row}
                                    type={"sub_grp"}
                                    options={handleGroupData("sub_grp_cy", row, "cy_map")}
                                    handleChange={handleMap}
                                    checkYearly={checkYearly}
                                    type2={"cy"}
                                    disabled={!edit}
                                  />
                                </td>
                              );
                            }
                            if (cell.column.Header == "FS GROUPING (PY)") {
                              return (
                                <td
                                  {...cell.getCellProps({
                                    style: {
                                      minWidth: cell.column.minWidth,
                                      width: cell.column.width,
                                      maxWidth: cell.column.maxWidth,
                                    },
                                  })}
                                  className="dropMapping"
                                >
                                  <SelectComponent
                                    rowData={row}
                                    type={"fs_grp"}
                                    options={handleGroupData("fs_grp_py", row, "py_map")}
                                    handleChange={handleMap}
                                    checkYearly={checkYearly}
                                    type2={"py"}
                                    disabled={!edit}
                                  />
                                </td>
                              );
                            }
                            if (cell.column.Header == "NOTES GROUPING (PY)") {
                              return (
                                <td
                                  {...cell.getCellProps({
                                    style: {
                                      minWidth: cell.column.minWidth,
                                      width: cell.column.width,
                                      maxWidth: cell.column.maxWidth,
                                    },
                                  })}
                                  className="dropMapping"
                                >
                                  <SelectComponent
                                    rowData={row}
                                    type={"note_grp"}
                                    options={handleGroupData("note_grp_py", row, "py_map")}
                                    handleChange={handleMap}
                                    checkYearly={checkYearly}
                                    type2={"py"}
                                    disabled={!edit}
                                  />
                                </td>
                              );
                            }
                            if (cell.column.Header == "SUB GROUPING (PY)") {
                              return (
                                <td
                                  {...cell.getCellProps({
                                    style: {
                                      minWidth: cell.column.minWidth,
                                      width: cell.column.width,
                                      maxWidth: cell.column.maxWidth,
                                    },
                                  })}
                                  className="dropMapping"
                                >
                                  <SelectComponent
                                    rowData={row}
                                    type={"sub_grp"}
                                    options={handleGroupData("sub_grp_py", row, "py_map")}
                                    handleChange={handleMap}
                                    checkYearly={checkYearly}
                                    type2={"py"}
                                    disabled={!edit}
                                  />
                                </td>
                              );
                            }

                            return (
                              <td {...cell.getCellProps()}>
                                {cell.render("Cell")}
                              </td>
                            );
                          })}
                        </tr>
                      );
                    })}
                  </tbody>
                </table>
              )}
            </div>
          </motion.div>
        </div>
      </div>
      {showSuccessPopup && (
        <div className={commoncss.overlay} style={{ position: "fixed", top: 0, left: 0, right: 0, bottom: 0, zIndex: 99999 }}>
          <div className={commoncss.popup} style={{ width: "380px", height: "245px"}}>
            <div className={commoncss.iconWrapper} >
              <img src={Checkmark} alt="Success" width={90} height={90} />
            </div>
            <p className={commoncss.restoreText}>Changes Saved Successfully</p>
          </div>
        </div>
      )}
    </>
  );
};

export default PreviewPage;